import React, {useEffect, useState} from "react";
import "./App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignInAlt,
  faChartBar,
  faLightbulb,
  faArrowLeft,
  faSearch,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import Header from './Header';
import store2 from './Store2.jpg';
import store3 from './Store3.jpg';
import store4 from './Store4.jpg';
import store5 from './Store5.jpg';
import store6 from './Store6.jpg'; // Assuming you have a Header component

const App = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [page, setPage] = useState("login");
  const [selectedFilter, setSelectedFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [selectedSolution, setSelectedSolution] = useState(null); // New state for solution selection

  const handleLogin = (e) => {
    e.preventDefault();
    setPage("main");
  };

  useEffect(() => {
    // Reset selectedSolution to null when navigating to the solution page
    if (page === "solution") {
      setSelectedSolution(null);
    }
  }, [page]);

  const handleSearch = () => {
    setPage("response");
  };

  const handleSolutionSelect = (solution) => {
    setSelectedSolution(solution);
  };

  return (
      <div className="app">
        <Header />
        <div className="page-container">
          {/* Login Page */}
          {page === "login" && (
              <div className="login-container card">
                <h2 className="title">Welcome Back</h2>
                <p className="subtitle">Sign into your account</p>
                <form className="login-form" onSubmit={handleLogin}>
                  <div className="input-group">
                    <label htmlFor="username">Username</label>
                    <input
                        type="text"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        placeholder="Enter username"
                    />
                  </div>
                  <div className="input-group">
                    <label htmlFor="password">Password</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        placeholder="Enter password"
                    />
                  </div>
                  <button type="submit" className="btn primary-btn">
                    <FontAwesomeIcon icon={faSignInAlt} /> Login
                  </button>
                </form>
                <a href="#forgot-password" className="forgot-password">
                  Forgot your password?
                </a>
                <div className="footer">
                  <span>www.tripl3s.com</span>
                  <span>Call Centre: +1(437)3395850</span>
                </div>
              </div>
          )}

          {/* Main Page */}
          {page === "main" && (
              <div className="main-container card">
                <h2 className="title">Dashboard</h2>
                <p className="subtitle">Select a process to begin</p>
                <div className="button-group">
                  <button className="btn primary-btn" onClick={() => setPage("report")}>
                    <FontAwesomeIcon icon={faChartBar} /> Reports
                  </button>
                  <button className="btn primary-btn" onClick={() => setPage("solution")}>
                    <FontAwesomeIcon icon={faLightbulb} /> Solutions
                  </button>
                </div>
                <div className="store-info">
                  <p><strong>Store:</strong> Sourena</p>
                  <p><strong>Version:</strong> V1.2</p>
                  <p><strong>Type:</strong> Grocery Store</p>
                </div>
                <div className="footer">
                  <span>www.tripl3s.com</span>
                  <span>Call Centre: +1(437)3395850</span>
                </div>
              </div>
          )}

          {/* Report Page */}
          {page === "report" && (
              <div className="report-container card">
                <div className="card-header">
                  <button className="btn back-btn" onClick={() => setPage("main")}>
                    <FontAwesomeIcon icon={faArrowLeft} /> Back
                  </button>
                  <h2 className="title">Generate Report</h2>
                </div>
                <div className="form-content">
                  <div className="date-time-group">
                    <div className="input-group">
                      <label>From Date</label>
                      <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                    </div>
                    <div className="input-group">
                      <label>To Date</label>
                      <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                    </div>
                    <div className="input-group">
                      <label>From Time</label>
                      <input type="time" value={fromTime} onChange={(e) => setFromTime(e.target.value)} />
                    </div>
                    <div className="input-group">
                      <label>To Time</label>
                      <input type="time" value={toTime} onChange={(e) => setToTime(e.target.value)} />
                    </div>
                  </div>
                  <div className="input-group">
                    <label>Filter By</label>
                    <select value={selectedFilter} onChange={(e) => setSelectedFilter(e.target.value)}>
                      <option value="number-of-customer">Number of Customers</option>
                      <option value="customer-information">Customer Information</option>
                      <option value="pause-location">Pause Location</option>
                      <option value="purchase-behavior">Purchase Behavior</option>
                      <option value="suspicious-behavior">Suspicious Behavior</option>
                      <option value="event-based">Event Based</option>
                    </select>
                  </div>
                  <button className="btn primary-btn" onClick={handleSearch}>
                    <FontAwesomeIcon icon={faSearch} /> Search
                  </button>
                </div>
                <div className="footer">
                  <span>www.tripl3s.com</span>
                  <span>Call Centre: +1(437)3395850</span>
                </div>
              </div>
          )}

          {/* Response Page */}
          {page === "response" && (
              <div className="response-container card">
                <div className="card-header">
                  <button className="btn back-btn" onClick={() => setPage("report")}>
                    <FontAwesomeIcon icon={faArrowLeft} /> Back
                  </button>
                  <h2 className="title">Report Results</h2>
                </div>
                <div className="response-content">
                  <h3 className="filter-title">Filter: {selectedFilter.replace(/-/g, ' ').toUpperCase()}</h3>
                  {selectedFilter === "customer-information" && (
                      <div className="report-data">
                        <p><strong>Period:</strong> March 3rd - June 3rd, 8:00 AM - 5:00 PM</p>
                        <div className="data-grid">
                          <div>Women Age Range: 15-60</div>
                          <div>Men Age Range: 18-54</div>
                          <div>Youngsters: 68%</div>
                          <div>Elderlies: 32%</div>
                          <div>Avg. Men Presence: 32 min</div>
                          <div>Avg. Women Presence: 45 min</div>
                        </div>
                        <div className="report-image">
                          <img src={store4} alt="Store Interior" />
                          <p className="image-caption">Snapshot of the store environment</p>
                        </div>
                        <button className="btn download-btn">
                          <FontAwesomeIcon icon={faDownload} /> Download
                        </button>
                      </div>
                  )}
                  {selectedFilter === "pause-location" && (
                      <div className="report-data">
                        <p><strong>Period:</strong> March 3rd - June 3rd, 8:00 AM - 5:00 PM</p>
                        <div className="data-grid">
                          <div>Women: Shelves A, B, C</div>
                          <div>Men: Shelf D</div>
                          <div>Young Girls: Shelf A</div>
                          <div>Young Boys: Shelf E</div>
                          <div>Overweight Women: Shelves B & C</div>
                          <div>No Pauses: Shelf F</div>
                        </div>
                        <div className="report-image">
                          <img src={store5} alt="Store Interior" />
                          <p className="image-caption">Snapshot of the store environment</p>
                        </div>
                        <button className="btn download-btn">
                          <FontAwesomeIcon icon={faDownload} /> Download
                        </button>
                      </div>
                  )}
                  {selectedFilter === "purchase-behavior" && (
                      <div className="report-data">
                        <p><strong>Period:</strong> March 3rd - June 3rd, 8:00 AM - 5:00 PM</p>
                        <div className="data-grid">
                          <div>Women Buyers: 72%</div>
                          <div>Peak Sales: 2:00 PM - 5:00 PM</div>
                          <div>Top Product: Q312 (Shelf A)</div>
                          <div>Young Buyers: 55%</div>
                          <div>Cash Queue: 63%</div>
                        </div>
                        <div className="report-image">
                          <img src={store2} alt="Store Interior" />
                          <p className="image-caption">Snapshot of the store environment</p>
                        </div>
                        <button className="btn download-btn">
                          <FontAwesomeIcon icon={faDownload} /> Download
                        </button>
                      </div>
                  )}
                </div>
                <div className="footer">
                  <span>www.tripl3s.com</span>
                  <span>Call Centre: +1(437)3395850</span>
                </div>
              </div>
          )}

          {/* Solution Page */}
          {page === "solution" && (
              <div className="solution-container card">
                <div className="card-header">
                  <button className="btn back-btn" onClick={() => setPage("main")}>
                    <FontAwesomeIcon icon={faArrowLeft} /> Back
                  </button>
                  <h2 className="title">Solutions</h2>
                </div>
                {!selectedSolution ? (
                    <div className="button-group">
                      <button className="btn primary-btn" onClick={() => handleSolutionSelect("simple")}>
                        Simple Change
                      </button>
                      <button className="btn primary-btn" onClick={() => handleSolutionSelect("infrastructural")}>
                        Infrastructural Changes
                      </button>
                      <button className="btn primary-btn" onClick={() => handleSolutionSelect("loyalty")}>
                        Enhance Customer Loyalty
                      </button>
                    </div>
                ) : (
                    <div className="solution-content">
                      {selectedSolution === "simple" && (
                          <div className="solution-section">
                            <h3 className="solution-title">Simple Changes</h3>
                            <p>Please press continue to see the situation</p>
                            <div className="solution-list">
                              <h4>Internal Condition</h4>
                              <ol>
                                <li>The light on shelf F is not sufficient, it should be exchanged with another one.</li>
                                <li>Wonderful pictures should be attached on the wall to attract more customers.</li>
                                <li>Giving a brochure to find each merchandise instead of hiring advisor.</li>
                                <li>Play a calm music.</li>
                                <li>The number of men are not noticeable you should bring attractive items for men.</li>
                              </ol>
                              <h4>Layout</h4>
                              <ol start="6">
                                <li>The number of women are significant, more products for women will increase sale.</li>
                                <li>Products which are for children should be aligned in lower floors of shelves.</li>
                                <li>Complementary goods are suggested to locate nearby each other.</li>
                              </ol>
                            </div>
                            <div className="report-image">
                              <img src={store6} alt="Store Interior" />
                              <p className="image-caption">Snapshot of the store environment</p>
                            </div>
                          </div>
                      )}
                      {selectedSolution === "infrastructural" && (
                          <div className="solution-section">
                            <h3 className="solution-title">Infrastructural Changes</h3>
                            <div className="solution-list">
                              <h4>Equipment</h4>
                              <ol>
                                <li>Trolleys in different size are needed.</li>
                                <li>Equip some useless locations by chairs for customers specially children and elderlies.</li>
                                <li>Preparing attractive items for children like (toys & candies).</li>
                              </ol>
                              <h4>Architectural Development</h4>
                              <ol start="4">
                                <li>Standard shelves should be replaced by taller shelves.</li>
                                <li>Corridors are suggested to become wider.</li>
                                <li>Considering cash gate to reduce expectancy time in cash queue.</li>
                                <li>Cash should be located near the Exit door.</li>
                                <li>The wall between corridor A & B should be removed.</li>
                                <li>Brush walls by energetic colors.</li>
                              </ol>
                              <h4>HR</h4>
                              <ol start="10">
                                <li>More supervisors are needed to conduct customers.</li>
                                <li>The average time related to queue is much higher than standard. Adding some cashes will be effectively appropriate.</li>
                              </ol>
                            </div>
                            <div className="report-image">
                              <img src={store5} alt="Store Interior" />
                              <p className="image-caption">Snapshot of the store environment</p>
                            </div>
                          </div>
                      )}
                      {selectedSolution === "loyalty" && (
                          <div className="solution-section">
                            <h3 className="solution-title">Enhance Customer Loyalty</h3>
                            <div className="solution-list">
                              <h4>Advertisement</h4>
                              <ol>
                                <li>Advertise products of shelf A on social media.</li>
                                <li>Create a new advertise campaign.</li>
                                <li>Introduce the benefits of consuming products on shelf D on the wall.</li>
                                <li>Give a membership card to customers.</li>
                              </ol>
                              <h4>Offers</h4>
                              <ol start="5">
                                <li>Give a new products as a discount beside another one in order to buy new products for the next time.</li>
                                <li>Holding simple events for special days.</li>
                                <li>Teach personnel to be more happier and energetic when they are advising customers.</li>
                              </ol>
                            </div>
                            <div className="report-image">
                              <img src={store4} alt="Store Interior" />
                              <p className="image-caption">Snapshot of the store environment</p>
                            </div>
                          </div>
                      )}
                    </div>
                )}
                <div className="footer">
                  <span>www.tripl3s.com</span>
                  <span>Call Centre: +1(437)3395850</span>
                </div>
              </div>
          )}
        </div>
      </div>
  );
};

export default App;